var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1.1 -1.1 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 8.2 0.9 a 1 1 0 0 0 0 14.6 c 2.1 -0.1 3.6 -0.7 5.1 -2.2 l 5.1 5.1 l -5.1 -5.1 c 4.4 -5 1.317 -12.285 -5.166 -12.4",
    stroke: "#009CC6",
    strokeWidth: 2,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.320e1564c283b2f0820c620746ea6b27.svg";
export { ForwardRef as ReactComponent };